// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RegisterDeviceInput-module-input-u5gct{width:100%}@media(min-width: 768px){.RegisterDeviceInput-module-input-u5gct{width:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "RegisterDeviceInput-module-input-u5gct"
};
export default ___CSS_LOADER_EXPORT___;
